module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/webber.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/webber.jpg
// module id = 604
// module chunks = 0